import React from 'react';

/**
 * Realtime WebSocket connection health badge.
 * @param {{ connected: boolean, lastUpdateAt?: Date|null, reconnectAttempt?: number }} props
 */
function RealtimeBadge({ connected, lastUpdateAt = null, reconnectAttempt = 0 }) {
  const lastStr = lastUpdateAt
    ? new Date(lastUpdateAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    : null;

  return (
    <span className={`ccv2-realtime-badge ${connected ? 'ccv2-realtime-connected' : 'ccv2-realtime-disconnected'}`}>
      <span className="ccv2-realtime-dot" />
      {connected ? 'Tempo real' : reconnectAttempt > 0 ? `Reconectando (${reconnectAttempt})` : 'Desconectado'}
      {connected && lastStr && (
        <span className="ccv2-realtime-time">{lastStr}</span>
      )}
    </span>
  );
}

export default React.memo(RealtimeBadge);
